import React, {useState, useEffect, useCallback} from "react"
import { 
  Autocomplete, 
  Box, 
  Grid, 
  TextField, 
  Divider, 
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography, Collapse, Stack, Chip
} from "@mui/material"
import {getFilters, getSubStringFilters, formatRemovalStatsString,getRangeFilters, formatFromReportDateString, formatRemovalStats } from '../../../../utils/helpers';
import { BooleanOptions, booleanStringType, SortType, FamilySortByType, FamilyUserTypeFilterType,dateRangeFilter, FamilyReportRangeFilterMapper,UsersRangeFilterOptions, UsersRangeFilterType, FamilyUserTypeFilterOptions,FamilyUsersType, AllFamilyStatsInitialState, subscriptionStatusFilterOptions, subscriptionStatusStringType ,
BrokerSourceOptions, BrokerSourceType, RemovalStatsType, SubscriptionTierOptions, SubscriptionTierFilterType} from "../Types"
import scan from '@meprism/shared/src/assets/icons/scan.svg'
import user from '@meprism/shared/src/assets/icons/participating.svg'
import PieChartCard from '../../../shared/atom/PieChart';
import dayjs from 'dayjs'
import CustomDatePicker from '../../../shared/atom/inputs/DatePicker';
import { ArrowDownward, ArrowUpward, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material"
import CustomTablePagination from "../../../shared/atom/TablePagination/TablePagination"
import {createPaginatedReportApi, PaginatedReportArgs, PaginatedReportReturn, createLookerAllFamilyStatsApi} from "../../../../redux/corporateCodeService"
import { useAppDispatch } from "../../../../redux/storeExports"
import {CircularProgress} from "@mui/material";
import { LookerReportsErrors } from '../../../shared/molecule/LookerReportsErrors';
import { capitalize } from 'lodash';

type FamilyReportProps = {
  familyReportSyncTime : string
};

export const FamilyTab=({familyReportSyncTime}: FamilyReportProps)=>{
    const dispatch = useAppDispatch()
    const [brokerSourceKey, setBrokerSourceKey] = useState<BrokerSourceType | ''>('')
    const [allFamilyStats, setAllFamilyStats] = useState<Record<string, RemovalStatsType | number>>(AllFamilyStatsInitialState)
    const [familyUserType, setFamilyUserType] = useState<FamilyUserTypeFilterType>('Parent')
    const [expandedMuid, setExpandedMuid] = useState('')
    const [searchValue, setSearchValue] = useState('')
    const [subscriptionTierFilter, setSubscriptionTierFilter] = useState<SubscriptionTierFilterType[]>([])    
    const [blastEmailFilter, setBlastEmailFilter] = useState<booleanStringType | ''>('')
    const [scanFilter, setScanFilter] = useState<booleanStringType | ''>('')
    const [startDate, setStartDate] = useState<dayjs.Dayjs | undefined>(undefined)
    const [endDate, setEndDate] = useState<dayjs.Dayjs | undefined>(undefined)
    const [brokerSourceFilter, setBrokerSourceFilter] = useState<BrokerSourceType|"">('')
    const [brokerSourceAllStatsFilter, setBrokerSourceAllStatsFilter] = useState<BrokerSourceType[]>([])
    const [sortType, setSortType] = useState<SortType>('DESC') 
    const [sortBy, setSortBy] = useState('parent_onboarding_date')
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [hasNext, setHasNext] = useState(false)
    const [refetch, setRefetch] = useState(true)
    const [fetchNextPage, setFetchNextPage] = useState(false)
    const [newPage, setNewPage] = useState(0)
    const [offset, setOffset] = useState(0)
    const colors = ['#C67EFF', '#426BF0', '#E2B93B', '#27AE60']; 
    const [sortStyle, setSortStyle] = useState({'parent_subscription_expire_time': 'ASC','parent_email':'ASC', 'parent_onboarding_date':'DESC', 'parent_name':'ASC', 'parent_records_found':'ASC', 'parent_records_removed':'ASC', 'parent_records_removing':'ASC', 'subscription_tier': 'ASC'})
    const [dateRangeFilterErrors, setDateRangeFilterErrors] = useState(dateRangeFilter);
    const [rangeFilter, setRangeFilter] = useState<UsersRangeFilterType | null>(null)
    const [loading, setIsLoading] = useState(false)
    const [familyUsers,setFamilyUsers] = useState<FamilyUsersType[]>([])
    const [getAllFamilyRemovalStats, setGetAllFamilyStats] = useState(true)
    const [getAllFamilyUsers, setGetAllFamilyUsers] = useState(true)
    const [subscriptionStatusFilter, setSubscriptionStatusFilter] = useState<subscriptionStatusStringType[]>([])

    const ToggleSort = useCallback((sortByValue: FamilySortByType, sortType?: SortType, refetch: boolean = true) => {
            if(sortByValue!=='parent_records_found' && sortByValue!=='parent_records_removed' && sortByValue!=='parent_records_removing'){
                setBrokerSourceFilter('')
            }
            const newSort = sortType? sortType : sortStyle[sortByValue] === 'ASC' ? 'DESC' : 'ASC'
            setSortStyle({ ...sortStyle, [sortByValue]: newSort })
            if(refetch){
                setSortType(newSort)
                setSortBy(sortByValue)
                setRefetch(true)
            }
    },[sortStyle])

    const getSortStyle = (sortByValue: FamilySortByType) => {
        const Icon = sortStyle[sortByValue] === 'DESC' ? ArrowDownward : ArrowUpward;
        const color = sortBy === sortByValue ? 'error' : 'primary';
        return <Icon color={color}/>;
    };

     useEffect(()=>{
        if(startDate && !endDate){
            setEndDate(dayjs())
        }
    }, [startDate, endDate])

    const getAllFamilyStats = useCallback(async () => {
            const familyStats = await dispatch(createLookerAllFamilyStatsApi()).unwrap()
            setAllFamilyStats(familyStats)
    }, [dispatch])

    useEffect(()=>{
        getAllFamilyStats()
    }, [getAllFamilyStats])

    useEffect(()=>{
            const fetchFamilyReport= async()=>{
                setIsLoading(true)
                let newOffset = 0;
                try{
                    if(fetchNextPage){
                        if(newPage < page){
                            newOffset = Math.max(offset - pageSize, 0)
                            setPage(page -1)
                        }else{
                            newOffset = pageSize + offset
                            setPage(page +1)
                    }
                    }
                    const subStringFilter = getAllFamilyUsers? '': searchValue
                    const formattedRangeFilter = FamilyReportRangeFilterMapper[rangeFilter as keyof typeof FamilyReportRangeFilterMapper]
                    let sortByRemovals = false
                    if(brokerSourceFilter && (sortBy!=='parent_records_found' && sortBy!=='parent_records_removed' && sortBy!=='parent_records_removing')){
                        setSortBy('parent_records_found')
                        setSortType('DESC')
                        ToggleSort('parent_records_found', 'DESC', false)
                        sortByRemovals = true
                    }
                     
                    if(brokerSourceFilter)setBrokerSourceKey(brokerSourceFilter)
                    else setBrokerSourceKey('')

                    const params : PaginatedReportArgs = {
                    "table" : "family_reporting",
                    "page_size": pageSize,
                    "sort_by": sortByRemovals? 'parent_records_found' : sortBy,
                    "offset" : fetchNextPage? newOffset : 0, 
                    "order" : sortByRemovals? 'DESC' : sortType,
                    "Filters":{
                        "filters": getFilters({parent_blast_emails_sent: blastEmailFilter? blastEmailFilter==='True': null, parent_first_scan_complete: scanFilter? scanFilter==='True': null, parent_subscription_status: subscriptionStatusFilter, "subscription_tier": subscriptionTierFilter}),
                        "search_filter" : getSubStringFilters(subStringFilter, familyUserType),
                        "date_range_filter": getRangeFilters([{rangeFilter: formattedRangeFilter, startDate, endDate}]),
                        "broker_source_filter": brokerSourceFilter? brokerSourceFilter: 'total'
                    }
                    }
                    const response : PaginatedReportReturn = await dispatch(createPaginatedReportApi(params)).unwrap()
                    setFamilyUsers(response.data)
                    setHasNext(response.has_next)
                }
                catch(e){
                    console.log('error getting looker family users report: ', e)
                }finally{
                    setIsLoading(false)
                    if (fetchNextPage) {
                        setOffset(newOffset)
                    } else {
                        setOffset(0)
                    }
                    setFetchNextPage(false)
                }
            }
            if(refetch){
                if(!fetchNextPage){
                    setPage(1)
                }
                if(getAllFamilyUsers){
                    setGetAllFamilyStats(true)
                }else{
                    setGetAllFamilyStats(false)
                }
                fetchFamilyReport()
            }
            setRefetch(false)
        },[refetch, searchValue, rangeFilter, startDate, endDate, dispatch, ToggleSort,
            blastEmailFilter, scanFilter, setGetAllFamilyStats, getAllFamilyUsers,
            pageSize, sortBy, sortType, offset, fetchNextPage, newPage, page, subscriptionStatusFilter, familyUserType,
            brokerSourceFilter, subscriptionTierFilter
        ])
    
        const getNextPage = (newPage: number)=>{
            setNewPage(newPage)
            setFetchNextPage(true)
            setRefetch(true)
        }
        
        const setNewPageSize = (newPageSize: number)=>{
            setPageSize(newPageSize)
            setRefetch(true)
        }


    const colStyle = {
        fontSize: '16px',
        whiteSpace: 'nowrap',
        minWidth: 'max-content',
        maxWidth: 'max-content'
    }

    const getRemovalsDetails=(title: string, recordString: string)=>{
            let records = formatRemovalStatsString(recordString)
            const {total, ...formattedRecords} = records
            records = {...formattedRecords, total} 
            return(
                <Paper
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    ...colStyle,
                    minWidth: "350px",
                    backgroundColor:"#f9f9f9",
                }}
                >
                <Typography variant="body2" fontWeight="bold" mx={10} sx={{whiteSpace:'wrap', wordBreak:'break-word'}}>
                    {title}
                </Typography>
                <Table size="small" sx={{ mt: 1, backgroundColor:'#fff'}} >
                    <TableBody>
                    {Object.entries(records).map(([key, value]) => (
                        <TableRow key={key}>
                        <TableCell>{key}</TableCell>
                        <TableCell>{value}</TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
                </Paper>
            )
        }

    const getRemovalChartData = () => {
        return [
            {
                value: familyUsers.length!==0 ? Number(formatRemovalStats(familyUsers[0]['child_records_removing'], brokerSourceAllStatsFilter)) + Number(formatRemovalStats(familyUsers[0]['parent_records_removing'], brokerSourceAllStatsFilter)) : 0,
                name: 'Records Removing',
                color: colors[2],
                icon: user
            },
            {
                value: familyUsers.length!==0 ? Number(formatRemovalStats(familyUsers[0]['child_records_removed'], brokerSourceAllStatsFilter)) + Number(formatRemovalStats(familyUsers[0]['parent_records_removed'], brokerSourceAllStatsFilter)) : 0,
                name: 'Records Removed',
                color: colors[0],
                icon: scan
            },
            {
                value: familyUsers.length!==0 ? Number(formatRemovalStats(familyUsers[0]['child_records_found'], brokerSourceAllStatsFilter)) + Number(formatRemovalStats(familyUsers[0]['parent_records_found'], brokerSourceAllStatsFilter)) : 0,
                name: 'Records Found',
                color: colors[3],
                icon: user
            }
        ];
    }

    const getAllRemovalChartData = () => {
        return [
            {
                value: Number(formatRemovalStats(allFamilyStats["total_records_removing"] as RemovalStatsType, brokerSourceAllStatsFilter)),
                name: 'Records Removing',
                color: colors[2],
                icon: user
            },
            {
                value: Number(formatRemovalStats(allFamilyStats["total_records_removed"] as RemovalStatsType, brokerSourceAllStatsFilter)),
                name: 'Records Removed',
                color: colors[0],
                icon: scan
            },
            {
                value: Number(formatRemovalStats(allFamilyStats["total_records_found"] as RemovalStatsType, brokerSourceAllStatsFilter)),
                name: 'Records Found',
                color: colors[3],
                icon: user
            }
        ];
    }
    
    const getSubscriptionStatusStyle = (status: string | null) => {
        return {
            backgroundColor: !status
                ? '#fff'
                : status === 'Active'
                ? '#46c563'
                : status === 'Expired'
                ? '#ff051eff'
                : status === 'Failed'
                ? '#b00020'
                : status === 'Free'
                ? '#fdd355'
                : '#fff',
            color:
                status === 'Expired' || status === 'Failed'
                ? '#fff'
                : 'inherit'
        }
    }


    const getParticipantChartData = () => {
        return [
            {
                value: Number(allFamilyStats["total_parents"]),
                name: 'Parent Family Users',
                color: colors[1],
                icon: user
            },
            {
                value: Number(allFamilyStats["total_children"]),
                name: 'Child Family Users',
                color: colors[0],
                icon: user
            }
        ];
    }

        const formatRemovalRecords = (record: string) =>{
            return brokerSourceKey ? 
            formatRemovalStatsString(record)[brokerSourceKey]: formatRemovalStatsString(record).total
        }


    const onFamilyUserSearch = () => {        
            const checkDateRangeError = Boolean(startDate || endDate || rangeFilter);
            if(checkDateRangeError){
                const newErrors = {
                    startDate: !startDate,
                    endDate: !endDate,
                    dateFilter: !rangeFilter,
                };
                const hasError = Object.values(newErrors).some(value => value === true);
                setDateRangeFilterErrors(newErrors);
                if (hasError) return
            }
            setDateRangeFilterErrors(dateRangeFilter)
            setRefetch(true);
    };

    return(
        <Box width={'100%'}>
            <Box sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>                
                <Grid container spacing={4} mb={5}>
                    <Grid item lg={12} md={12} xs={12} mb={2} sx={{display:'flex'}}>
                        <Box
                            sx={{border:'1px green solid', backgroundColor:"white", py:3, px:2, borderRadius:2, color:"green"}}
                        >
                            <Typography variant='h4' sx={{color:'success.main'}}>Last Data Sync: {familyReportSyncTime}</Typography>
                        </Box>
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <TextField
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            label="Search by Muid or Email"
                            size="small"
                            fullWidth
                        />
                    </Grid>
                     <Grid item lg={2} md={6} xs={12}>
                        <Autocomplete
                            options={FamilyUserTypeFilterOptions}
                            value={familyUserType}
                            onChange={(event, newValue) => {
                                newValue? setFamilyUserType(newValue as FamilyUserTypeFilterType) : setFamilyUserType('Parent');
                            }}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Family User Type"
                            />
                            )}
                            defaultValue={'Parent'}
                            fullWidth
                            isOptionEqualToValue={(option, value) => option === value}
                        />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Button
                            variant="contained"
                            disabled={loading}
                            color="primary"
                            onClick={()=>{
                                setGetAllFamilyUsers(false) 
                                setRefetch(true)}}
                            sx={{width: '48%', height: '100%', mr:'2%'}}                                                    
                        >
                            Search
                        </Button>
                        <Button
                            variant="contained"
                            disabled={loading}
                            color="primary"
                            onClick={()=>{
                                setGetAllFamilyUsers(true)
                                setSearchValue('')
                                setRefetch(true)
                            }}
                            sx={{width: '48%', height: '100%'}}                                                    
                        >
                            Get All Family Users
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Divider sx={{mt: 5, mb: 5}}/>
            <Autocomplete
                multiple
                options={BrokerSourceOptions}
                value={brokerSourceAllStatsFilter}
                onChange={(event, newValue) => {
                    setBrokerSourceAllStatsFilter(newValue);
                }}
                clearOnEscape
                renderInput={(params) => (
                <TextField
                    {...params}
                    label="Broker Source"
                />
                )}
                fullWidth
                limitTags={1}
                isOptionEqualToValue={(option, value) => option === value}
                renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip label={option} {...getTagProps({ index })} />
                ))
                }
                sx={{width: '25%', height: '10%'}}
            />
            <Grid container spacing={4} mt={1} mb={10} width={'100%'}>
                <Grid item lg={6} md={6} xs={12}>
                    <PieChartCard
                        title="Removal Stats"
                        chartData={getAllFamilyRemovalStats? getAllRemovalChartData(): getRemovalChartData()}
                        bgcolor={'#C67EFF33'}
                    />
                </Grid>
                <Grid item lg={6} md={6} xs={12}>
                    <PieChartCard
                        title="Participant Stats"
                        chartData={getParticipantChartData()}
                        bgcolor={'#C67EFF33'}
                    />
                </Grid>
            </Grid>
            {loading?
                <Box
                sx={{
                    width: '100%',
                    height: '50vh',
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}>
                <CircularProgress sx={{ alignSelf: 'center', justifySelf: 'center' }} />
            </Box>:<>
            <Box sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                <Grid container spacing={4} mb={5}>
                    <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            options={BooleanOptions}
                            value={scanFilter}
                            onChange={(event, newValue) => {
                                setScanFilter(newValue as booleanStringType);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="First Scan Complete"
                            />
                            )}
                            fullWidth
                            isOptionEqualToValue={(option, value) => option === value}
                        />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            options={BooleanOptions}
                            value={blastEmailFilter as booleanStringType}
                            onChange={(event, newValue) => {
                                setBlastEmailFilter(newValue as booleanStringType);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Blast Email Sent"
                            />
                            )}
                            fullWidth
                            isOptionEqualToValue={(option, value) => option === value}
                        />
                    </Grid>
                     <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            multiple
                            options={subscriptionStatusFilterOptions}
                            value={subscriptionStatusFilter}
                            onChange={(event, newValue) => {
                                setSubscriptionStatusFilter(newValue);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Subscription Status"
                            />
                            )}
                            fullWidth
                            limitTags={1}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip label={option} {...getTagProps({ index })} />
                            ))
                            }
                        />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            multiple
                            options={SubscriptionTierOptions}
                            value={subscriptionTierFilter}
                            onChange={(event, newValue) => {
                                setSubscriptionTierFilter(newValue);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Subscription Tier"
                            />
                            )}
                            fullWidth
                            limitTags={1}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip label={option} {...getTagProps({ index })} />
                            ))
                            }
                        />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            options={BrokerSourceOptions}
                            value={brokerSourceFilter}
                            onChange={(event, newValue) => {
                                setBrokerSourceFilter(newValue as BrokerSourceType);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Broker Source"
                            />
                            )}
                            fullWidth
                            limitTags={1}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip label={option} {...getTagProps({ index })} />
                            ))
                            }
                        />
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Autocomplete
                            options={UsersRangeFilterOptions}
                            value={rangeFilter}
                            onChange={(event, newValue) => {
                                setRangeFilter(newValue as UsersRangeFilterType);
                            }}
                            clearOnEscape
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Filter By Date"
                            />
                            )}
                            fullWidth
                            isOptionEqualToValue={(option, value) => option === value}
                        />
                        {
                            dateRangeFilterErrors['dateFilter'] && <LookerReportsErrors errorKey='date type' filter='date'/>
                        }
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <CustomDatePicker
                            label="Start Date"
                            value={startDate? startDate : null}
                            onChange={(value)=>{value? setStartDate(value): setStartDate(undefined)}}
                            disableFuture
                            clearable
                            maxDate={endDate}
                        />
                        {
                            dateRangeFilterErrors['startDate'] && <LookerReportsErrors errorKey='start date' filter='date'/>
                        }
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <CustomDatePicker
                            label="End Date"
                            value={endDate? endDate : null}
                            onChange={(value)=>{value? setEndDate(value): setEndDate(undefined)}}
                            disableFuture
                            clearable
                            minDate={startDate}
                        />
                        {
                            dateRangeFilterErrors['endDate'] && <LookerReportsErrors errorKey='end date' filter='date'/>
                        }
                    </Grid>
                    <Grid item lg={4} md={6} xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={()=>onFamilyUserSearch()}
                            sx={{width: '50%', height: '47px'}}                                                    
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <TableContainer component={Paper} style={{ marginTop: 20 }}>
                <Table sx={{minWidth: 1400, overflow: 'auto' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>MUID</TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Email
                                    <Button onClick={(e: React.MouseEvent)=>
                                            {
                                                setSortBy('parent_email')
                                                ToggleSort('parent_email')
                                            }}
                                    >
                                        {getSortStyle('parent_email')}
                                    </Button>
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Name
                                    <Button onClick={(e: React.MouseEvent)=>
                                            {
                                                setSortBy('parent_name')
                                                ToggleSort('parent_name')
                                            }}
                                    >
                                            {getSortStyle('parent_name')}
                                    </Button>
                                </Box>
                            </TableCell>
                            <TableCell>Records Found
                                <Button onClick={(e: React.MouseEvent)=>
                                            {
                                                setSortBy('parent_records_found')
                                                ToggleSort('parent_records_found')
                                            }}
                                        >
                                        {getSortStyle('parent_records_found')}
                                </Button>
                            </TableCell>
                            <TableCell>Records Removed
                                <Button onClick={(e: React.MouseEvent)=>
                                            {
                                                setSortBy('parent_records_removed')
                                                ToggleSort('parent_records_removed')
                                            }}
                                        >
                                        {getSortStyle('parent_records_removed')}
                                </Button>
                            </TableCell>
                            <TableCell>Records Removing
                                <Button onClick={(e: React.MouseEvent)=>
                                        {
                                            setSortBy('parent_records_removing')
                                            ToggleSort('parent_records_removing')
                                        }}
                                    >
                                    {getSortStyle('parent_records_removing')}
                                </Button>
                            </TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Onboaring Date
                                    <Button onClick={(e: React.MouseEvent)=>
                                                {
                                                    setSortBy('parent_onboarding_date')
                                                    ToggleSort('parent_onboarding_date')
                                                }}
                                            >
                                            {getSortStyle('parent_onboarding_date')}
                                    </Button>
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Subscription Status
                                </Box>
                            </TableCell>
                            <TableCell>Subscription Tier
                                <Button onClick={(e: React.MouseEvent)=>
                                            {
                                                setSortBy('subscription_tier')
                                                ToggleSort('subscription_tier')
                                            }}
                                    >
                                            {getSortStyle('subscription_tier')}
                                    </Button>
                            </TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center" gap={1}>
                                    Subscription Expires At 
                                    <Button onClick={(e: React.MouseEvent)=>
                                                {
                                                    setSortBy('parent_subscription_expire_time')
                                                    ToggleSort('parent_subscription_expire_time')
                                                }}
                                            >
                                            {getSortStyle('parent_subscription_expire_time')}
                                    </Button>
                                </Box>
                            </TableCell>
                            <TableCell>Blast Emails Sent</TableCell>
                            <TableCell>First Scan Complete</TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {   Array.isArray(familyUsers) &&
                            familyUsers.length===0 &&
                                <TableRow>
                                    <TableCell colSpan={11} sx={{textAlign:"center"}}>
                                        No Match Found
                                    </TableCell>
                                </TableRow>
                        }
                        {Array.isArray(familyUsers) && familyUsers.length!==0 && familyUsers
                            .map((user: FamilyUsersType, index: number) => (
                            <>
                                <TableRow
                                    key={index}
                                    sx={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}
                                >
                                    <TableCell>
                                        <Button onClick={()=>expandedMuid===user.parent_muid?setExpandedMuid(''):setExpandedMuid(user.parent_muid)}>
                                            {expandedMuid===user.parent_muid?
                                            <KeyboardArrowUp/> :
                                            <KeyboardArrowDown/>}
                                        </Button>
                                    </TableCell>
                                    <TableCell sx={{...colStyle}}>{user.parent_muid}</TableCell>
                                    <TableCell sx={{...colStyle}}>{user.parent_email? user.parent_email : '-'}</TableCell>
                                    <TableCell sx={{...colStyle}}>{user.parent_name? user.parent_name : '-'}</TableCell>
                                    <TableCell sx={{...colStyle, minWidth:220}}>{formatRemovalRecords(user.parent_records_found)}</TableCell>
                                    <TableCell sx={{...colStyle, minWidth:230}}>{formatRemovalRecords(user.parent_records_removed)}</TableCell>
                                    <TableCell sx={{...colStyle, minWidth:230}}>{formatRemovalRecords(user.parent_records_removing)}</TableCell>
                                    <TableCell sx={{...colStyle, minWidth:200}}>{user.parent_onboarding_date? formatFromReportDateString(user.parent_onboarding_date):'-'}</TableCell>
                                    <TableCell sx={{...colStyle, minWidth:200, ...getSubscriptionStatusStyle(user.parent_subscription_status)}}>{user.parent_subscription_status? capitalize(user.parent_subscription_status):'-'}</TableCell>
                                    <TableCell sx={{...colStyle, minWidth: 200}}>{user.subscription_tier? user.subscription_tier : '-'}</TableCell>
                                    <TableCell sx={{...colStyle, minWidth:250}}>{user.parent_subscription_expire_time? formatFromReportDateString(user.parent_subscription_expire_time):'-'}</TableCell>
                                    <TableCell sx={{...colStyle, minWidth:170}}>{user.parent_blast_emails_sent? capitalize(user.parent_blast_emails_sent):'-'}</TableCell>
                                    <TableCell sx={{...colStyle, minWidth:190}}>{user.parent_first_scan_complete? capitalize(user.parent_first_scan_complete):'-'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={13} sx={{ paddingBottom: 0, paddingTop: 0 }}>
                                        <Collapse
                                        in={expandedMuid === user.parent_muid}
                                        timeout="auto"
                                        unmountOnExit
                                        >
                                            {user.child_muid && <Stack spacing={4} px={2} py={4} direction={'row'} sx={{
                                                minHeight: '120px',
                                                height: 'auto',
                                                maxHeight: 'max-content'  
                                            }}>
                                                    <Typography variant="h3" alignSelf={'center'} maxWidth={100} minWidth={100}>
                                                        Child Details
                                                    </Typography>
                                                    <Paper sx={{display:'flex', alignItems:'center', padding:'20px', ...colStyle}}>
                                                        <Typography variant="body2" fontWeight={'bold'}>
                                                            Child MUID :&nbsp; 
                                                        </Typography>
                                                        <Typography variant="body2"> 
                                                            {user.child_muid? user.child_muid: 'None'}
                                                        </Typography>
                                                    </Paper>
                                                     <Paper sx={{display:'flex', alignItems:'center', padding:'20px', ...colStyle}}>
                                                        <Typography variant="body2" fontWeight={'bold'}>
                                                            Child Email:&nbsp;
                                                        </Typography>
                                                        <Typography variant="body2"> 
                                                            {user.child_email ? user.child_email: 'None'}
                                                        </Typography>
                                                    </Paper>
                                                    <Paper sx={{display:'flex', alignItems:'center', padding:'20px', ...colStyle}}>
                                                        <Typography variant="body2" fontWeight={'bold'}>
                                                            Child Name :&nbsp; 
                                                        </Typography>
                                                        <Typography variant="body2"> 
                                                            {user.child_name? user.child_name : 'None'}
                                                        </Typography>
                                                    </Paper>
                                                    <Paper sx={{display:'flex', alignItems:'center', padding:'20px', ...colStyle}}>
                                                        <Typography variant="body2" fontWeight={'bold'}>
                                                            Child Records Found:&nbsp;
                                                        </Typography>
                                                        <Typography variant="body2"> 
                                                            {formatRemovalRecords(user.child_records_found)}
                                                        </Typography>
                                                    </Paper>
                                                    <Paper sx={{display:'flex', alignItems:'center', padding:'20px', ...colStyle}}>
                                                        <Typography variant="body2" fontWeight={'bold'}>
                                                            Child Records Removed:&nbsp;
                                                        </Typography>
                                                        <Typography variant="body2"> 
                                                            {formatRemovalRecords(user.child_records_removed)}
                                                        </Typography>
                                                    </Paper>
                                                    <Paper sx={{display:'flex', alignItems:'center', padding:'20px', ...colStyle}}>
                                                        <Typography variant="body2" fontWeight={'bold'}>
                                                            Child Records Removing:&nbsp;
                                                        </Typography>
                                                        <Typography variant="body2"> 
                                                            {formatRemovalRecords(user.child_records_removing)}
                                                        </Typography>
                                                    </Paper>
                                                    <Paper sx={{display:'flex', alignItems:'center', padding:'20px', ...colStyle}}>
                                                        <Typography variant="body2" fontWeight={'bold'}>
                                                            Child Onboarding Date:&nbsp;
                                                        </Typography>
                                                        <Typography variant="body2"> 
                                                            {user.child_onboarding_date ? formatFromReportDateString(user.child_onboarding_date): 'None'}
                                                        </Typography>
                                                    </Paper>
                                                    <Paper sx={{display:'flex', alignItems:'center', padding:'20px', ...colStyle}}>
                                                        <Typography variant="body2" fontWeight={'bold'}>
                                                            Child Subscription Status:&nbsp;
                                                        </Typography>
                                                        <Typography variant="body2"> 
                                                            {user.child_subscription_status ? user.child_subscription_status: 'None'}
                                                        </Typography>
                                                    </Paper>
                                                    <Paper sx={{display:'flex', alignItems:'center', padding:'20px', ...colStyle}}>
                                                        <Typography variant="body2" fontWeight={'bold'}>
                                                            Child Subscription Expires At:&nbsp;
                                                        </Typography>
                                                        <Typography variant="body2"> 
                                                            {user.child_subscription_expire_time ? formatFromReportDateString(user.child_subscription_expire_time): 'None'}
                                                        </Typography>
                                                    </Paper>
                                                    <Paper sx={{display:'flex', alignItems:'center', padding:'20px', ...colStyle}}>
                                                        <Typography variant="body2" fontWeight={'bold'}>
                                                            Child Blast Emails Sent:&nbsp;
                                                        </Typography>
                                                        <Typography variant="body2"> 
                                                            {user.child_blast_emails_sent? capitalize(user.child_blast_emails_sent):'None'}
                                                        </Typography>
                                                    </Paper>
                                                    <Paper sx={{display:'flex', alignItems:'center', padding:'20px', ...colStyle}}>
                                                        <Typography variant="body2" fontWeight={'bold'}>
                                                            Child First Scan Complete:&nbsp;
                                                        </Typography>
                                                        <Typography variant="body2"> 
                                                            {user.child_first_scan_complete? capitalize(user.child_first_scan_complete):'None'}
                                                        </Typography>
                                                    </Paper>
                                                    
                                            </Stack>}
                                            <Stack spacing={4} px={2} py={4} direction={'row'} sx={{
                                                minHeight: '120px',
                                                height: 'auto',
                                                maxHeight: 'max-content'  
                                            }}>
                                                    <Typography variant="h3" alignSelf={'center'} maxWidth={150} minWidth={150}>
                                                        Parent Removals Details
                                                    </Typography>
                                                    {getRemovalsDetails('Records Found', user.parent_records_found)}
                                                    {getRemovalsDetails('Records Removed', user.parent_records_removed)}
                                                    {getRemovalsDetails('Records Removing', user.parent_records_removing)}
                                            </Stack>
                                            {user.child_muid &&
                                                <Stack spacing={4} px={2} py={4} direction={'row'} sx={{
                                                minHeight: '120px',
                                                height: 'auto',
                                                maxHeight: 'max-content'  
                                            }}>
                                                    <Typography variant="h3" alignSelf={'center'} maxWidth={150} minWidth={150}>
                                                        Child Removals Details
                                                    </Typography>
                                                    {getRemovalsDetails('Records Found', user.child_records_found)}
                                                    {getRemovalsDetails('Records Removed', user.child_records_removed)}
                                                    {getRemovalsDetails('Records Removing', user.child_records_removing)}
                                            </Stack>}
                                        </Collapse>
                                    </TableCell>
                                </TableRow>
                            </>                                
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <CustomTablePagination
                onPageChange={(newPage: number) => getNextPage(newPage)}
                onPageSizeChange={(pageSize: number) =>
                    setNewPageSize(pageSize)
                }
                page={page}
                pageSize={pageSize}
                hasNext={hasNext}
            />        
        </>}
        </Box>
    )
}